export const getMicroAppId = () => {
    return `${process.env.REACT_APP_MICRO_APP_ID}`;
};
